import React, { Fragment } from "react";
import { Button } from "semantic-ui-react";

/**
 * @author
 * @function ButtonAwesome
 **/

const ButtonAwesome = ({onQueryButtonClicked}) => {
  return (
    <Fragment>
      <Button style = {{borderRadius : '0px',height : "38px",marginBottom : "20px",marginTop : "2px"}} onClick ={() => onQueryButtonClicked("query")}>
          Why hire me?
      </Button>
    </Fragment>
  );
};

export default ButtonAwesome;
